export default [
    {
        name: 'menus',
        path: '/menus',
        component: () => import(/* webpackChunkName: "menus" */'./components/menus.vue')
    },
    {
        name: 'dashboard',
        path: '/dashboard/:ic?',
        props: true,
        component: () => import(/* webpackChunkName: "dashboard" */'./components/Dashboard.vue')
    },
    {
        name: 'profile',
        path: '/profile',
        component: () => import(/* webpackChunkName: "profile" */'./components/Profile.vue')
    },
    {
        name: 'users',
        path: '/users',
        component: () => import(/* webpackChunkName: "users" */'./components/Users.vue')
    },
    {
        name: 'userview',
        path: '/userview/:uuid',
        component: () => import(/* webpackChunkName: "userview" */'./components/user/view.vue')
    },
    {
        name: 'schoolsystems',
        path: '/schoolorgs',
        component: () => import(/* webpackChunkName: "schoolsystems" */'./components/schoolsystem/Schoolsystem.vue')
    },
    {
        name: 'schoolsystemview',
        path: '/schoolorg/view/:uuid',
        component: () => import(/* webpackChunkName: "schoolsystemview" */'./components/schoolsystem/view.vue')
    },
    {
        name: 'setuporg',
        path: '/setuporg',
        component: () => import(/* webpackChunkName: "setuporg" */'./components/schoolsystem/setuporg.vue')
    },
    {
        name: 'setupschool',
        path: '/setupschool',
        component: () => import(/* webpackChunkName: "setupschool" */'./components/school/setupschool.vue')
    },
    {
        name: 'schooltype',
        path: '/schoolprograms',
        component: () => import(/* webpackChunkName: "schooltype" */'./components/school/Schooltypes.vue')
    },
    {
        name: 'gradelevel',
        path: '/gradelevel',
        component: () => import(/* webpackChunkName: "gradelevel" */'./components/school/Gradelevels.vue')
    },
    {
        name: 'department',
        path: '/department',
        component: () => import(/* webpackChunkName: "department" */'./components/school/Departments.vue')
    },
    {
        name: 'school',
        path: '/schools',
        component: () => import(/* webpackChunkName: "school" */'./components/school/Schools.vue')
    },
    {
        name: 'schoolview',
        path: '/school/view/:uuid',
        component: () => import(/* webpackChunkName: "schoolview" */'./components/school/view.vue')
    },
    {
        name: 'course',
        path: '/courses',
        component: () => import(/* webpackChunkName: "course" */'./components/course/Courses.vue')
    },
    {
        name: 'courseview',
        path: '/course/view/:uuid',
        component: () => import(/* webpackChunkName: "courseview" */'./components/course/view.vue')
    },
    {
        name: 'mastercourseview',
        path: '/mastercourse/view/:uuid',
        component: () => import(/* webpackChunkName: "mastercourse" */'./components/course/viewmaster.vue')
    },
    {
        name: 'unit',
        path: '/units',
        component: () => import(/* webpackChunkName: "unit" */'./components/unit/Units.vue')
    },
    {
        name: 'unitview',
        path: '/unit/view/:uuid',
        component: () => import(/* webpackChunkName: "unitview" */'./components/unit/view.vue')
    },
    {
        name: 'masterunitview',
        path: '/masterunit/view/:uuid',
        component: () => import(/* webpackChunkName: "masterunit" */'./components/unit/viewmaster.vue')
    },
    {
        name: 'lesson',
        path: '/lessons',
        component: () => import(/* webpackChunkName: "lesson" */'./components/lesson/Lessons.vue')
    },
    {
        name: 'lessonview',
        path: '/lesson/view/:uuid',
        component: () => import(/* webpackChunkName: "course" */'./components/lesson/view.vue')
    },
    {
        name: 'masterlessonview',
        path: '/masterlesson/view/:uuid',
        component: () => import(/* webpackChunkName: "masterlesson" */'./components/lesson/viewmaster.vue')
    },
    {
        name: 'assignment',
        path: '/assignments/:type',
        component: () => import(/* webpackChunkName: "assignment" */'./components/assignment/Assignments.vue')
    },
    {
        name: 'projectassignment',
        path: '/projectassignments/:type',
        component: () => import(/* webpackChunkName: "assignmentproject" */'./components/assignment/AssignmentsProject.vue')
    },
    {
        name: 'assignmentview',
        path: '/assignment/view/:uuid',
        component: () => import(/* webpackChunkName: "assignmentview" */'./components/assignment/view.vue')
    },
    {
        name: 'projectview',
        path: '/project/view/:uuid',
        component: () => import(/* webpackChunkName: "projectview" */'./components/assignment/viewproject.vue')
    },
    {
        name: 'masterassignmentview',
        path: '/masterassignment/view/:uuid',
        component: () => import(/* webpackChunkName: "masterassignmentview" */'./components/assignment/viewmaster.vue')
    },
    {
        name: 'planner',
        path: '/planner',
        component: () => import(/* webpackChunkName: "planner" */'./components/planner/Planner.vue')
    },
    {
        name: 'coursegradebook',
        path: '/course/gradebook',
        component: () => import(/* webpackChunkName: "coursegradebook" */'./components/gradebook/gradebookbycourse.vue')
    },
    {
        name: 'studentgradebook',
        path: '/student/gradebook',
        component: () => import(/* webpackChunkName: "coursegradebook" */'./components/gradebook/gradebookbysinglestudent.vue')
    },
    {
        name: 'questionCreateDaily',
        path: '/questioncreate',
        component: () => import(/* webpackChunkName: "questionCreateDaily" */'./components/ExamsDailyQuestions/createQuestions.vue')
    },
    {
        name: 'draftque',
        path: '/draftque',
        component: () => import(/* webpackChunkName: "draftque" */'./components/ExamsDailyQuestions/draftQuestions.vue')
    },
    {
        name: 'dailyQueScore',
        path: '/dailyQueScore',
        component: () => import(/* webpackChunkName: "dailyQueScore" */'./components/ExamsDailyQuestions/dailyQueScore.vue')
    },
    {
        name: 'notifications',
        path: '/notifications',
        component: () => import(/* webpackChunkName: "notifications" */'./components/notification/notifications.vue')
    },
    {
        name: 'userdashboard',
        path: '/userdashboard',
        component: () => import(/* webpackChunkName: "userdashboard" */'./components/dashboard/userdashboard.vue')
    },
    {
        name: 'bestpractice',
        path: '/bestpractice',
        component: () => import(/* webpackChunkName: "bestpractice" */'./components/bestpractice/bestpractice.vue')
    },
    {
        name: 'performancealert',
        path: '/performancealert',
        component: () => import(/* webpackChunkName: "performancealert" */'./components/performancealert/index.vue')
    },
    {
        name: 'recommendation',
        path: '/recommendation',
        component: () => import(/* webpackChunkName: "recommendation" */'./components/recommendation/index.vue')
    },
    {
        name: 'invitation',
        path: '/invitations',
        component: () => import(/* webpackChunkName: "invitation" */'./components/invitation/index.vue')
    },
    {
        name: 'announcement',
        path: '/announcements',
        component: () => import(/* webpackChunkName: "announcement" */'./components/announcement/index.vue')
    },
    {
        name: 'share',
        path: '/share',
        component: () => import(/* webpackChunkName: "share" */'./components/share/index.vue')
    },
    {
        name: 'genius',
        path: '/genius',
        component: () => import(/* webpackChunkName: "genius" */'./components/geniusfinder/index.vue')
    },
    {
        name: 'attendance',
        path: '/attendance',
        component: () => import(/* webpackChunkName: "attendance" */'./components/attendance/attendance.vue')
    },
    {
        name: 'myworld',
        path: '/myworld',
        component: () => import(/* webpackChunkName: "myworld" */'./components/schoolsystem/view_world.vue')
    },
    {
        name: 'worldcourse',
        path: '/worldcourse',
        component: () => import(/* webpackChunkName: "worldcourse" */'./components/course/CoursesWorld.vue')
    },
    {
        name: 'viewworldcourse',
        path: '/viewworldcourse/:id',
        component: () => import(/* webpackChunkName: "viewworldcourse" */'./components/course/viewworld.vue')
    },
    {
        path: '/gradelevelperformance/:id',
        name: 'gradelevelperformance',
        component: () => import(/* webpackChunkName: "gradelevelperformance" */'./components/dashboard/gradelevel_performance.vue'),
    },
    {
        path: '/genderperformance/:id',
        name: 'genderperformance',
        component: () => import(/* webpackChunkName: "genderperformance" */'./components/dashboard/gender_performance.vue'),
    },
    {
        path: '/courseperformance/:id',
        name: 'courseperformance',
        component: () => import(/* webpackChunkName: "courseperformance" */'./components/dashboard/course_performance.vue'),
    },
    {
        path: '/sgenderp/:school_id/:gender',
        name: 'sgenderp',
        component: () => import(/* webpackChunkName: "sgenderp" */'./components/dashboard/sgenderp.vue'),
    },
    {
        path: '/sgp/:school_id/:id',
        name: 'sgp',
        component: () => import(/* webpackChunkName: "sgp" */'./components/dashboard/sgp.vue'),
    },
    {
        path: '/scp/:school_id/:id',
        name: 'scp',
        component: () => import(/* webpackChunkName: "scp" */'./components/dashboard/scp.vue'),
    },
    {
        path: '/sup/:id',
        name: 'sup',
        component: () => import(/* webpackChunkName: "sup" */'./components/dashboard/sup.vue'),
    },
    {
        path: '/slp/:id',
        name: 'slp',
        component: () => import(/* webpackChunkName: "scp" */'./components/dashboard/slp.vue'),
    },
    {
        path: '/sap/:id',
        name: 'sap',
        component: () => import(/* webpackChunkName: "scp" */'./components/dashboard/sap.vue'),
    },
    {
        path: '/unitperformance/:id',
        name: 'unitperformance',
        component: () => import(/* webpackChunkName: "unitperformance" */'./components/dashboard/unit_performance.vue'),
    },
    {
        path: '/lessonperformance/:id',
        name: 'lessonperformance',
        component: () => import(/* webpackChunkName: "lessonperformance" */'./components/dashboard/lesson_performance.vue'),
    },
    {
        path: '/assignmentperformance/:type/:id',
        name: 'assignmentperformance',
        component: () => import(/* webpackChunkName: "assignmentperformance" */'./components/dashboard/assignment_performance.vue'),
    },
    {
        path: '/cal',
        name: 'cal',
        component: () => import(/* webpackChunkName: "cal" */'./components/calendar/cal.vue'),
    },
    {
        path: '/recyclebin',
        name: 'recyclebin',
        component: () => import(/* webpackChunkName: "recyclebin" */'./components/recycle/recycle.vue'),
    },
    {
        path: '/testfile',
        name: 'testfile',
        component: () => import(/* webpackChunkName: "testfile" */'./components/dashboard/testfile.vue'),
    }
    // import QuestionsDaily from './components/ExamsDailyQuestions/Questions.vue';
    // import questionsDailyPreview from './components/ExamsDailyQuestions/questionPreview.vue';
    // import dailyQueScore from './components/ExamsDailyQuestions/dailyQueScore.vue';
];
